import React from "react";
import {
  Button,
  Row,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import {
  registerUser,
  registerUserAD,
  addCustomLabs,
  getAllCustomLabs,
  addLabs
} from "../../actions";
import { toast, ToastContainer } from "react-toastify";
import "react-input-range/lib/css/index.css";
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import "./registerUser.css";
import NavBar from "../../components/NavBar/navBar";
import Tour from "../../Tour";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin, appInsights } from "../../AppInsights";
import { SeverityLevel } from "@microsoft/applicationinsights-common";
import {
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import registerUserIcon from '../../assets/register-user.svg'
import jwt_decode from "jwt-decode";

let errorDetails = "";

class RegisterUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      email: '',



      // Logged in user' lab 
      loggedUserLab: this.settingRole(),

      // New created user's role
      role: localStorage.getItem("auth_token") ? jwt_decode(localStorage.getItem("auth_token")).is_staff ? 'admin' : 'contributor' : 'contributor',
      loggedInUserEmail: localStorage.getItem("auth_token") ? jwt_decode(localStorage.getItem("auth_token")).unique_name : '',

      // To check if loggged in user is a Superuser or not
      isStaff: localStorage.getItem("auth_token") ? jwt_decode(localStorage.getItem("auth_token")).is_staff : false,

      // User group For the person logged in
      userGroup: localStorage.getItem("auth_token") ? jwt_decode(localStorage.getItem("auth_token")).user_group == 'admin' ? true : false : false,

      // New created user's lab
      // lab: localStorage.getItem("auth_token") ? jwt_decode(localStorage.getItem("auth_token")).roles? jwt_decode(localStorage.getItem("auth_token")).roles.length>0? jwt_decode(localStorage.getItem("auth_token")).roles[0]!='PathoSuperLab'? jwt_decode(localStorage.getItem("auth_token")).roles[0] : '' : '':'' : '',
      lab: this.setUserLab(),
      isAddLabModalOpen: false,
      newLab: '',
      newConfirmLab: '',
      allLabs: []
    }
  }

  settingRole = (data = false) => {
    const token_decoded = localStorage.getItem("auth_token") ? jwt_decode(localStorage.getItem("auth_token")) : '';
    let lab = ''

    if (token_decoded.is_external) {
        lab = token_decoded.lab || ''
    }
    else if(token_decoded.roles && token_decoded.roles.length > 0){
        lab = token_decoded.roles[0]
    }
    return lab
}

  componentDidMount() {
    const token_decoded = localStorage.getItem("auth_token") ? jwt_decode(localStorage.getItem("auth_token")) : '';
    this.labListFunction()
    let userEmail = token_decoded.unique_name
    let isStaff = token_decoded.is_staff
    this.setUserLab()
    this.setState({
      loggedInUserEmail: userEmail,
      isStaff: isStaff
    })
  }

  capitalizeFirstLetter = (data) => {
    return data.charAt(0).toUpperCase() + data.slice(1);
  }

  onSetUsername = (event) => {
    this.setState({
      username: event.target.value
    })
  }

  onSetNewLab = (event) => {
    this.setState({
      newLab: event.target.value
    })
  }

  onSetNewConfirmLab = (event) => {
    this.setState({
      newConfirmLab: event.target.value
    })
  }

  onSetEmail = (event) => {
    this.setState({
      email: event.target.value
    })
  }

  setUserRole = (event) => {
    this.setState({
      role: event.target.value
    })
  }

  setUserLab = (event) => {
    if (event != undefined) {
        this.setState({ lab: event.target.value })
        return
    }
    const decoded = localStorage.getItem("auth_token") ? jwt_decode(localStorage.getItem("auth_token")) : null;
    const lab = decoded?.roles?.[0] && decoded.roles[0] !== 'PathoSuperLab' 
        ? decoded.roles[0] 
        : decoded?.lab || '';
    this.setState({ lab })
}

  validData = (data) => {
    if (data.username && this.validateEmail(data.email) && data.lab && data.role) {
      return true
    }
    else if (!data.username) {
      errorDetails = "Please enter a username!"
      return false
    }
    else if (!this.validateEmail(data.email)) {
      errorDetails = data.email ? "Entered email is invalid!" : 'Please enter an Email!'
      return false
    }
    else if (!data.lab) {
      errorDetails = "Please enter a Lab name!"
      return false
    }
    else if (!data.role) {
      errorDetails = "Please select a role!"
      return false
    }
    else {
      errorDetails = "Please check all the fields!"
      return false
    }

  }

  validateEmail = (mail) => {
    if (String(mail).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
      return true
    }
    return false
  }

  formClear = () => {
    this.setState({
      username: '',
      email: '',
      lab: '',
    })
  }

  formSubmit = async () => {
    if (this.validData(this.state)) {
      let data = {
        username: this.state.username,
        lab: this.state.lab,
        user_group: this.state.role,
        email: this.state.email.toLowerCase(),
      }
      let response
      if('token_type' in jwt_decode(localStorage.getItem("auth_token"))){
        response = await this.props.registerUser(data)
      }
      else{
        data['secretKey'] = 'a_secret_secret_key'
        response = await this.props.registerUserAD(data)
      }
      
      if (response.status == 200 || response.status == 201) {
        let message = "New user, " + this.state.username + " added to your lab!"
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT
        });
        this.setState({
          username: '',
          email: ''
        })
      }
      else {
        errorDetails = "Addition of user was not successful"
        this.ErrorDetails()
      }
    }
    else {
      this.ErrorDetails()
    }
  }

  ErrorDetails = () => {
    appInsights.trackTrace({ message: errorDetails, properties: { page: "resultDisplay" }, severityLevel: SeverityLevel.Verbose })
    toast.error(errorDetails, {
      position: toast.POSITION.BOTTOM_RIGHT
    })
    errorDetails = ""
    return true
  }

  toggleAddLabModal = () => {
    this.setState(prevState => ({
      isAddLabModalOpen: !prevState.isAddLabModalOpen,
    }));
  }

  labListFunction = async () => {
    const response = await this.props.getAllCustomLabs()
    let labs = []
    if (response.status == 200 || response.status == 201) {
      for (let key in response.data) {
        if (response.data[key]['name'] != 'PathoSuperLab') {
          labs.push(response.data[key]['name'])
        }
      }
    }

    if (labs.length > 0) {
      this.setState({
        lab: labs[0]
      }, () => {
        this.setUserLab();
      })
    }

    this.setState({
      allLabs: labs
    })
  }

  validLabData = (data) => {
    if (!data.newLab) {
      errorDetails = "Please enter a lab!"
      return false
    }
    else if (!data.newConfirmLab) {
      errorDetails = "Please confirm the lab name!"
      return false
    }
    else if (data.newLab != data.newConfirmLab) {
      errorDetails = "Lab names do not match!"
      return false
    }
    else if (this.state.allLabs.includes(data.newLab)) {
      errorDetails = "Lab name already exists!"
      return false
    }
    else if (data.newLab == data.newConfirmLab) {
      return true
    }
  }

  saveNewLabData = async () => {
    if (this.validLabData(this.state)) {
      let data = {
        name: this.state.newLab,
      }
      const response_old = await this.props.addLabs(data);
      const response = await this.props.addCustomLabs(data);
      if (response.status == 200 || response.status == 201 && response_old.status == 200 || response_old.status == 201 ) {
      // if (response.status == 200 || response.status == 201) {

        let message = "New lab, " + this.state.newLab + " added!"
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT
        });

        //To update lab list after addition of new lab
        this.labListFunction()

        this.setState({
          newConfirmLab: '',
          newLab: ''
        })
      }
      else {
        errorDetails = "Addition of lab was not successful"
        this.ErrorDetails()
      }
    }
    else {
      this.ErrorDetails()
    }
  }

  resetData = () => {
    this.setState({
      newConfirmLab: '',
      newLab: ''
    })
  }

  render() {
    return (
      <div data-tut="reactour__register" className="page-layout">
        <NavBar />
        <div className="dashboard-overview results-page">
          <Card className="entire-card" data-tut="reactour__registeruser">
            <CardHeader className="register-new-users heading-font-style">
              <img className="register-user-icon" src={registerUserIcon} responsive />
              Register User
            </CardHeader>
            <CardBody>
              <Form id="stripe-login" className="registration-form">
                <Row>
                  <div class="field padding-bottom--24 col-6">
                    <div class="grid--50-50">
                      <label for="email" className="register-form-text">Username <span className="required-icon">*</span></label>
                    </div>
                    <input className="form-field-option" onChange={(event) => this.onSetUsername(event)} type="email" name="email" value={this.state.username} />
                  </div>
                  <div class="field padding-bottom--24 col-6">
                    <div class="grid--50-50">
                      <label for="email-2" className="register-form-text">User email <span className="required-icon">*</span></label>
                    </div>
                    <input className="form-field-option" onChange={(event) => this.onSetEmail(event)} type="email" name="email-2" value={this.state.email} />
                  </div>
                </Row>
                <Row>
                  <div class="field padding-bottom--24 col-6">
                    <label for="lab" className="register-form-text">Lab <span className="required-icon">*</span></label>
                    {this.state.isStaff && this.state.loggedUserLab && this.state.loggedUserLab.includes('PathoSuperLab') ?
                      <Input className={this.state.lab ? "overlay-inputs overlay-selected role-input" : "overlay-inputs overlay-select role-input"} type="select" name="role" id="role" value={this.state.lab} onChange={(event) => { this.setUserLab(event) }}>
                        <option value="Select Lab" id="Select Lab" key="Select Lab" default selected hidden disabled>Select Lab</option>
                        {this.state.allLabs.map((lab, key) => {
                          if (lab != 'PathoSuperLab') {
                            return <option id={lab} key={lab} value={lab}>{lab}</option>
                          }
                        })}
                      </Input>
                      :
                      <input disabled className="form-field-option" type="text" name="lab" value={this.state.loggedUserLab} />
                    }

                  </div>
                  <div class="field padding-bottom--24 col-6">
                    <div class="grid--50-50">
                      <label for="role" className="register-form-text">Assigned Role <span className="required-icon">*</span></label>
                    </div>

                    {this.state.isStaff && this.state.loggedUserLab && this.state.loggedUserLab.includes('PathoSuperLab') ?
                      <Input className={this.state.role ? "overlay-inputs overlay-selected role-input" : "overlay-inputs overlay-select role-input"} type="select" name="role" id="role" value={this.state.role} onChange={this.setUserRole}>
                        <option value="contributor" default>Contributor</option>
                        <option value="admin">Admin</option>
                      </Input>
                      :
                      <Input className={this.state.role ? "overlay-inputs overlay-selected role-input" : "overlay-inputs overlay-select role-input"} type="select" name="role" id="role" value={this.state.role} onChange={this.setUserRole}>
                        <option value="contributor" default>Contributor</option>
                        <option value="admin">Admin</option>
                      </Input>
                    }
                  </div>
                </Row>

                <Row>
                  <div class="field padding-bottom--24">
                    <Button className="button-size custom-button save-upload-delete-button button-margin" id="save" onClick={this.formSubmit}>Add User</Button>
                  </div>
                </Row>
              </Form>

            </CardBody>
          </Card>

          {/* For custom login, lab is checked below because only superuser has lab as PathoSuperLab. And role is checked for internal user */}
          {(this.state.isStaff && this.state.loggedUserLab && this.state.loggedUserLab.includes('PathoSuperLab')) ?
            <Card className="entire-card">
              <CardHeader className="register-new-users heading-font-style">
                Add Lab
              </CardHeader>
              <CardBody>
                <Button className="button-size custom-button add-lab-button save-upload-delete-button" value="AddBuilding" onClick={this.toggleAddLabModal}>Add Lab</Button>
              </CardBody>
            </Card>
            : null
          }

        </div>

        <Modal isOpen={this.state.isAddLabModalOpen} toggle={this.toggleAddLabModal}>
          <ModalHeader toggle={this.toggleAddLabModal} className="edit-popup hover-move">Add a Lab</ModalHeader>
          <ModalBody>
            <Form onSubmit={this.handleFormSubmit}>
              <FormGroup>
                <Label className="location-label-names">Lab Name<span className="required-icon">*</span></Label>
                <Input className="add-location-unit" type="text" name="labName" id="LabName" value={this.state.newLab} onChange={(event) => this.onSetNewLab(event)} size="1" placeholder="Ex: Lab name" />

                <Label className="location-label-names">Confirm Lab Name<span className="required-icon">*</span></Label>
                <Input className="add-location-unit" type="text" name="confirmLabName" id="LabName" value={this.state.newConfirmLab} onChange={(event) => this.onSetNewConfirmLab(event)} size="1" placeholder="Ex: lab name" />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter className="float-sm-right bottom-options">
            <Button className="button-size custom-button cancel-button mr-2" outline color="secondary" onClick={() => this.resetData()}>Clear</Button>
            <Button className="button-size custom-button save-upload-delete-button" id="save" onClick={() => this.saveNewLabData()}>Save</Button>
          </ModalFooter>
        </Modal>

        <ToastContainer autoClose={3000} />
        {this.props.isTourOpen ? (
          <Tour
            isOpen={this.props.isTourOpen}
            closeTour={this.props.closeTour}
            openTour={this.props.openTour}
          />
        ) : null}
      </div >
    );
  }
}

const mapStateToProps = (state) => {
  return {
    filters: state.results_data.filters,
    locationList: state.sample_data.locationList,
    buildingList: state.floor_data.buildingsList,
    floorsList: state.floor_data.floorsList,
    initialState: state.results_data.initialState,
    speciesList: state.results_data.speciesList,
    sampleData: state.sample_data.downloadSampleData,
  };
};

export default withAITracking(
  reactPlugin,
  connect(mapStateToProps, {
    registerUser,
    registerUserAD,
    addCustomLabs,
    getAllCustomLabs,
    addLabs
  })(RegisterUser),
  "RegisterUser",
  "RegisterUser"
);
